import React from "react";

import Header from "./Header";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-page)" }}>
      <Header />

      <section className="section">
        <div className="container max-w-4xl">
          <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
            <div className="container max-w-4xl mx-auto">
              <h1 className="heading-1 mb-6">Politique de confidentialite</h1>

              <p className="body-medium mb-6">
                Cette politique de confidentialite decrit la maniere dont{" "}
                <strong>Fold Web Agency</strong> collecte et utilise les donnees
                personnelles de ses visiteurs et clients, conformement au RGPD et a
                la loi Informatique et Libertes.
              </p>

              <p className="body-medium mb-8">
                La presente politique est applicable exclusivement au site{" "}
                <strong>https://fold-web-agency.fr</strong>.
              </p>

              <h2 className="heading-2 mt-10 mb-4">
                1. Responsable du traitement et hebergement
              </h2>

              <div className="overflow-x-auto">
                <table className="w-full border border-gray-200 text-sm">
                  <tbody>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Nom et statut</td>
                      <td className="border px-4 py-2">Patrice Tord</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Adresse postale</td>
                      <td className="border px-4 py-2">
                        44 bis Boulevard de la Republique, 93130 Noisy-le-Sec
                      </td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Coordonnees</td>
                      <td className="border px-4 py-2">contact@fold-web-agency.fr</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Numero SIRET</td>
                      <td className="border px-4 py-2">81927317800023</td>
                    </tr>
                    <tr>
                      <td className="border px-4 py-2 font-semibold">Hebergeur</td>
                      <td className="border px-4 py-2">
                        OVH SAS - 2 rue Kellermann, 59100 Roubaix, France
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2 className="heading-2 mt-10 mb-4">
                2. Donnees collectees et finalites
              </h2>

              <ul className="list-disc pl-6 body-medium space-y-2">
                <li>
                  <strong>Formulaire de contact :</strong> nom, email, telephone,
                  message, utilises uniquement pour repondre a votre demande.
                </li>
                <li>
                  <strong>Espace client et tickets :</strong> nom, email, entreprise,
                  contenu des demandes, historique de statut et pieces jointes sont
                  traites pour assurer le suivi du support et des interventions.
                </li>
                <li>
                  <strong>Aucun tracking :</strong> aucun outil de mesure d'audience
                  ou de publicite n'est utilise.
                </li>
              </ul>

              <h2 className="heading-2 mt-10 mb-4">
                3. Duree de conservation
              </h2>

              <ul className="list-disc pl-6 body-medium space-y-2">
                <li>Donnees de contact : 3 ans apres le dernier echange</li>
                <li>Donnees de tickets support : 3 ans apres le dernier echange</li>
                <li>Donnees de facturation : 10 ans (obligation legale)</li>
              </ul>

              <h2 className="heading-2 mt-10 mb-4">4. Vos droits</h2>

              <p className="body-medium mb-4">
                Vous disposez des droits d'acces, de rectification, d'effacement, de
                limitation, d'opposition et de portabilite de vos donnees.
              </p>

              <p className="body-medium mb-4">
                Pour exercer ces droits, contactez :
                <strong> contact@fold-web-agency.fr</strong>
              </p>

              <p className="body-medium">
                Vous pouvez egalement introduire une reclamation aupres de la CNIL.
              </p>

              <h2 className="heading-2 mt-10 mb-4">
                5. Cookies et securite
              </h2>

              <p className="body-medium">
                Le site utilise uniquement des cookies techniques necessaires a son
                fonctionnement. Aucune donnee n'est utilisee a des fins publicitaires
                ou statistiques.
              </p>

              <p className="italic text-gray-500 mt-10">
                Derniere mise a jour : 18 avril 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
